import { productUpdatesReactiveVar } from '../../productUpdatesReactiveVar';
const useUpdatePUTableCache = () => ({
  addToCache: rolloutProductUpdates => {
    if (!rolloutProductUpdates || !Array.isArray(rolloutProductUpdates)) {
      return;
    }

    // add product updates to cache
    const newProductUpdatesCache = new Map(productUpdatesReactiveVar());
    rolloutProductUpdates.forEach(pu => {
      newProductUpdatesCache.set(`${pu.id}`, pu);
    });
    productUpdatesReactiveVar(newProductUpdatesCache);
    return;
  },
  updateCache: (productUpdateId, newPU) => {
    if (!productUpdateId) {
      return;
    }

    // update cache
    const newProductUpdatesCache = new Map(productUpdatesReactiveVar());
    const pu = newProductUpdatesCache.get(`${productUpdateId}`);
    if (!pu) {
      return;
    }
    newProductUpdatesCache.set(`${productUpdateId}`, Object.assign({}, pu, newPU));
    productUpdatesReactiveVar(newProductUpdatesCache);
    return;
  }
});
export default useUpdatePUTableCache;